import React, { useCallback, useMemo } from 'react';
import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import { CultureIndexCulture } from 'types/Meteorology/Agro/CultureIndex/culture';
import useCultures from 'hooks/Meteorology/Agro/CultureIndex/Area/useCultures';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

export default function Culture({ map }: {
  map: CultureIndexAreaMap,
}) {
  const {
    cultures,
    setCulture,
  } = useCultures(map);
  const closeAccordion = useMemo(
    () => buildAccordionClickFunction(`culture-index-culture-${map.id}`),
    [map.id],
  );
  const setCultureAndClose = useCallback((culture: CultureIndexCulture) => {
    setCulture(culture);
    closeAccordion();
  }, [setCulture, closeAccordion]);

  return (
    <Accordion.Item eventKey="culture" id={`culture-index-culture-${map.id}`}>
      <Accordion.Header>Cultura</Accordion.Header>
      <Accordion.Body>
        {cultures.map((culture) => (
          <RadioButton
            className="my-2"
            key={culture.name}
            label={culture.label}
            checked={map.params.culture?.name === culture.name}
            onChange={() => setCultureAndClose(culture)}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
